<template>
  <div class="">
    <CCardHeader v-if="alertValue">
      <!-- <CAlert show color="danger">
        {{ alertValue }}
      </CAlert> -->
        <CAlert  show color="danger">
                      <div  v-if="alertValue&&alertValue.hasOwnProperty('valueList')">
                <p  v-for="(value,index) in alertValue.valueList" :key="index">
                        {{value}}
                      </p>
                      </div>
                      <div v-if="alertValue&&alertValue.hasOwnProperty('codeList')">
                      <span>{{$t("cAlert.errorCode")+' : '}}</span><span  v-for="(code,index) in alertValue.codeList" :key="index">
                        {{code +' '}}
                      </span>
                      </div>
                            <div  v-if="alertValue&&alertValue.constructor==String">
                <p  >
                        {{alertValue}}
                      </p>
                      </div>
                      </CAlert>
    </CCardHeader>

    <ValidationProvider tag="div" rules="checkOne" v-slot="{ errors }">

        <div class="payment-setup-checkbox">
          <div v-if="paymentTypes && paymentTypes.B2B && paymentTypes.B2B.length" class="payment-t">
            <div class="p-type">
              {{ $t("cB2BPayment.b2b")+' ' }} {{ $t("cB2BPayment.payment") }}
            </div>

            <div @change="onTypeChange">
              <div v-for="(pType, index) in paymentTypes.B2B" :key="index" class="d-flex justify-content-start">
                <div class="checkbox-wrap-payment-c" :class="{disable :isSetup&& !pType.isActive}">

                    <input
                            :disabled="isSetup"
                            type="checkbox"
                            :checked='pType.isActive '
                            :value="paymentTypes"
                            @input="pType.isActive = !pType.isActive"
                            :id="'c'+index"
                            class="d-none"
                    />

                    <label  :for="'c'+index">
                      <span>

                      </span>
                      <div>
                        {{ pType.typename }}
                      </div>
                    </label>




                </div>
                <CCol v-if="isSetup" class="mb-10px">
                  <CCol>
                    <CButton
                            :disabled="isSetup && !pType.isActive"
                            @click="showPaymentFeeModal(pSettID, pType.payment_type)"
                            class="btn btn-manage b-radius-3px hover-none btn-success btn-sm"
                    >
                                           {{ $t("cB2BPayment.setup") }}
                    </CButton>
                  </CCol>
                </CCol>
              </div>
            </div>
          </div>
          <div v-if="paymentTypes && paymentTypes.B2C && paymentTypes.B2C.length" class="payment-t">
            <strong>
              {{ $t("cB2BPayment.b2c") }}
            </strong>

            <div @change="onTypeChange">
              <div
                      class="d-flex justify-content-start"
                      v-for="(pType, index) in paymentTypes.B2C"
                      :key="index"
              >
                <div :class="{disable : isSetup&& ! pType.isActive}" class="checkbox-wrap-payment-c ">
                  <input
                          :disabled="isSetup"
                          type="checkbox"
                          :value="paymentTypes"
                          :checked='pType.isActive '
                          @input="pType.isActive = !pType.isActive"
                          class="d-none"
                          :id="'a'+index"
                  />

                  <label :for="'a'+index">
                     <span>

                      </span>
                  <div>  {{ pType.typename }}</div>
                  </label>
                </div>

                <CCol v-if="isSetup" class="mb-10px">
                  <CCol >
                    <CButton
                            :disabled="isSetup && !pType.isActive"
                            @click="showPaymentFeeModal(pSettID, pType.payment_type)" class="btn btn-manage b-radius-3px hover-none btn-success btn-sm"

                    >
                    
                     {{ $t("cB2BPayment.setup") }}
                    </CButton>
                  </CCol>
                </CCol>
                <br />
              </div>
            </div>
          </div>
        </div>






      <div class="invalid-feedback ">
        <div>
          <span>{{ errors[0] }}</span>
        </div>
      </div>
    </ValidationProvider>
    <ValidationObserver v-slot="{ handleSubmit }">
          <CForm @submit.prevent="handleSubmit(updatePaymentFee)">

    <CModal
      v-if="showFeeModal"
      :title="$t('cB2BPayment.fee')"
      :show.sync="showFeeModal"
      :closeOnBackdrop="false"
      centered
      size="lg"
    >
      <CCardBody>
       
            <div v-if="lsPaymentFee && lsPaymentFee.length">
              <CRow v-for="(payment, index) in lsPaymentFee" :key="index + ''">
                <CCol>
                  <div @change="isApplyAll = false" v-if="!index">
                    <cTextInputComponent
                      :label="$t('cB2BPayment.name')"
                      v-model="payment.texttodisplay"
                      @input="assignNameToAllCurr"
                      :rules="'required|max:20'"
                    >
                    </cTextInputComponent>
                  </div>

                  <cTextInputComponent
                    v-else
                    :label="$t('cB2BPayment.name')"
                    v-model="payment.texttodisplay"
                    :rules="'required|max:20'"
                  >
                  </cTextInputComponent>
                  <div class=""></div>
                </CCol>

                <CCol style=" ">
                    <label>
                      {{ $t("cB2BPayment.perc") }}
                    </label>
                  <ValidationProvider
                    tag="div"
                      rules="required|validDecimal|onlynumber|max_val:100"
                    v-slot="{ errors }"
                  >
                    <div class="input-group "  >
                      <div class="input-group-prepend">
                        <span class="input-group-text">{{
                          payment.currency
                        }}</span>
                      </div>

                      <input @blur="payment.fee_perc=remPercentageDeci(payment.fee_perc)"
                         type="text"
                        class="form-control"
                      
                        :maxlength="5"
                        v-model="payment.fee_perc"
                      />
                    </div>
                    <div v-if=" errors && errors[0]" class="invalid-feedback icon">
                      <span>{{ errors[0] }}</span>
                    </div>
                  </ValidationProvider>
                </CCol>

                <CCol>

                    <label>
                      {{ $t("cB2BPayment.fixedAmount") }}
                    </label>

                  <ValidationProvider
                    tag="div"
                    rules="required|validDecimal|onlynumber"
                    v-slot="{ errors }"
                  >
                    <div class="input-group "
                   >
                      <div class="input-group-prepend">
                        <span class="input-group-text">{{
                          payment.currency
                        }}</span>
                      </div>

                      <input 
                      @click="payment.fee_amount=onRemoveCurrFormat(payment.fee_amount)"
                      @blur="payment.fee_amount=formatCurrency(payment.fee_amount, payment.currency)"
                        type="text"
                        :maxlength="getMaxCharacters(payment.fee_amount)"
                        min="0"
                        class="form-control"
                        v-model="payment.fee_amount"
                      />
                    </div>
                    <div v-if="errors && errors[0]" class="invalid-feedback icon">
                      <span>{{ errors[0] }}</span>
                    </div>
                  </ValidationProvider>
                </CCol>
              </CRow>
            </div>
         
      </CCardBody>

      <template #footer-wrapper>

        <CCardFooter class="card-footer d-flex justify-content-end">
          <CAlert v-if="alertValue" show color="danger">
            {{ alertValue }}
          </CAlert>
          <CButton type="submit" class=" btn-manage b-radius-3px hover-none btn-success ">
            {{ $t("cB2BPayment.save") }}
          </CButton>
        </CCardFooter>
      </template>
    </CModal>
     </CForm>
        </ValidationObserver>
    <cAlertModal
      v-if="isShowAlertModal"
      :buttonList="getAlertModalBtn()"
      :status="1"
      :show="isShowAlertModal"
      :desc="$t('cB2BPayment.feeStatus')"
    >
    </cAlertModal>
  </div>
</template>
<script>
import {
  VALIDATE_SUCCESS_RES,
  getErrorMessage
} from "../../util/apiValidate.js";
import { handleJWT, getErrorAlertValue, cloneData,removeCurrFormat } from "../../util/util";
import { ValidationObserver, ValidationProvider, localize } from "vee-validate";
import BaseConfiguration from "../../config/base";
import apiGetAllPaymentTypes from "./../../services/apiGetAllPaymentTypes";
import apiGetPaymentFee from "./../../services/apiGetPaymentFee";
import apiUpdatePaymentFee from "./../../services/apiUpdatePaymentFee";
import { COMPONENT_NAME, PATHNAME } from "../../util/constants";
import cTextInputComponent from "../form/cTextInputComponent";
import cAlertModal from "../form/cAlertModal";
import cCurrencyBoxes from "../currency/cCurrencyBoxes";
import apiCreateRole from "../../services/apiCreateRole.js";
import Logger from "../../services/logger";
// import nb from "../../../src/translations/validation/nb.json";
// import en from "../../../src/translations/validation/en.json";
import {
  LOG_TYPE,
  FILE_NAME,
  HTTP_CODES,
  API_VALUES
} from "../../config/API_DATA";
// localize({
//   en: {
//     messages: en.messages
//   },
//   nb: {
//     messages: nb.messages
//   }
// });
export default {
  name: COMPONENT_NAME.C_PAYMENT_TYPES,
  components: {
    ValidationProvider,
    ValidationObserver,
    cTextInputComponent,
    cCurrencyBoxes,
    cAlertModal
  },
  props: {
    isSetup: {
      type: Boolean,
      default: false
    },

    pSettID: {
      type: Number,
      default: null
    },

    selPayments: {
      type: Array,
      default: null
    }
  },

  data: () => {
    return {
      showFeeModal: false,
      alertValue: null,
      paymentTypes: null,
      isShowAlertModal: false,
      lsPaymentFee: [],
      isApplyAll: true,
      lsSelectedPayments: []
    };
  },

  methods: {
    onRemoveCurrFormat(pValue) {
         let retValue;
        try {
          if(BaseConfiguration.isDebug) console.log("onRemoveCurrFormat");
       
       retValue= removeCurrFormat( pValue);
        } catch (err) {
                let body = Logger.buildRequest(
                   FILE_NAME.C_PAYMENT_TYPES,
                  "error in onRemoveCurrFormat",
                  err.toString(),
                  "onRemoveCurrFormat",
                  LOG_TYPE.ERROR
                );
                Logger.getResponse(body);
              }
          return retValue;
        }, 
       ///if amount field to get max characters
     getMaxCharacters(pAmount) {
        try {
          if(BaseConfiguration.isDebug) console.log("getMaxCharacters");
          let retValue;
        if(pAmount){
    if(pAmount.toString().includes('.')){
     let indexOfDot=pAmount.toString().indexOf(".");
     if(indexOfDot==14){
        retValue= 17;

     } else if(indexOfDot==13){
           retValue= 16;
     }
     else{
            retValue=15;
     }
 }  else{
     retValue=15;
 }
        }
        
        return retValue;
        }
    
         catch (err) {
                let body = Logger.buildRequest(
                   FILE_NAME.C_PAYMENT_TYPES,
                  "error in getMaxCharacters",
                  err.toString(),
                  "getMaxCharacters",
                  LOG_TYPE.ERROR
                );
                Logger.getResponse(body);
              }
         
        },
    ///to remove decimal if > 100
    remPercentageDeci(pCurrVal){
      try{
        if(pCurrVal>=100&&pCurrVal.toString().includes('.')){
          return 100;
        }else{
          return pCurrVal;
        }
       
      }catch (err) {
          let body = Logger.buildRequest(
          'cCurrencyBoxes',
          "error in remPercentageDeci",
          err.toString(),
          "remPercentageDeci",
          LOG_TYPE.ERROR
        );
        Logger.getResponse(body);
      }

    },

    formatCurrency(pValue,pCurrency) {
   let retValue;
        try {
          if(BaseConfiguration.isDebug) console.log("formatCurrency");
       

       retValue=   this.$options.filters.currencyFormat(pValue,pCurrency);
    //  console.error(this.$options.filters.currencyFormat(pValue,pCurrency));

    
        } catch (err) {
                let body = Logger.buildRequest(
                  FILE_NAME.C_PAYMENT_TYPES,
                  "error in formatCurrency",
                  err.toString(),
                  "formatCurrency",
                  LOG_TYPE.ERROR
                );
                Logger.getResponse(body);
              }

              return retValue;
       
        }, 

    getAlertModalBtn() {
      let retValue;
      try {
        if (BaseConfiguration.isDebug) console.log("getAlertModalBtn");

        retValue = [
          {
            name: this.$t("cB2BPayment.ok"),
            func: this.toggleAlertModal
          }
        ];
      } catch (err) {
        let body = Logger.buildRequest(
          FILE_NAME.C_PAYMENT_TYPES,
          "error in getAlertModalBtn",
          err.toString(),
          "getAlertModalBtn",
          LOG_TYPE.ERROR
        );
        Logger.getResponse(body);
      }
      return retValue;
    },

    toggleAlertModal() {
      try {
        if (BaseConfiguration.isDebug) console.log("toggleAlertModal");
        this.isShowAlertModal = !this.isShowAlertModal;
      } catch (err) {
        let body = Logger.buildRequest(
          FILE_NAME.C_PAYMENT_TYPES,
          "error in toggleAlertModal",
          err.toString(),
          "toggleAlertModal",
          LOG_TYPE.ERROR
        );
        Logger.getResponse(body);
      }
    },

    assignNameToAllCurr(pName) {
      try {
        if (BaseConfiguration.isDebug) console.log("assignNameToAllCurr");

        if (this.lsPaymentFee && this.lsPaymentFee.length && this.isApplyAll) {
          this.lsPaymentFee.forEach((payment, index) => {
            payment.texttodisplay = pName;
          });
        }
      } catch (err) {
        let body = Logger.buildRequest(
          FILE_NAME.C_PAYMENT_TYPES,
          "error in assignNameToAllCurr",
          err.toString(),
          "assignNameToAllCurr",
          LOG_TYPE.ERROR
        );
        Logger.getResponse(body);
      }
    },
    onTypeChange() {
      this.$emit("change", cloneData(this.paymentTypes));
    },

    hidePaymentFeeModal() {
      try {
        if (BaseConfiguration.isDebug) console.log("hidePaymentFeeModal");
        this.showFeeModal = false;
      } catch (err) {
        let body = Logger.buildRequest(
          FILE_NAME.C_PAYMENT_TYPES,
          "error in hidePaymentFeeModal",
          err.toString(),
          "hidePaymentFeeModal",
          LOG_TYPE.ERROR
        );
        Logger.getResponse(body);
      }
    },

    async showPaymentFeeModal(pPsettID, pPtype) {
      try {
        if (BaseConfiguration.isDebug) console.log("showPaymentFeeModal");

        this.showFeeModal = true;
        this.isApplyAll=true
        this.lsPaymentFee = await this.getPaymentFee(pPsettID, pPtype);
        this.formatLsPaymentFee();
      } catch (err) {
        let body = Logger.buildRequest(
          FILE_NAME.C_PAYMENT_TYPES,
          "error in showPaymentFeeModal",
          err.toString(),
          "showPaymentFeeModal",
          LOG_TYPE.ERROR
        );
        Logger.getResponse(body);
      }
    },
    
    formatLsPaymentFee() {
        try {
          if(BaseConfiguration.isDebug) console.log("formatLsPaymentFee");
          
          for(let i=0;i<this.lsPaymentFee.length;i++){
            this.lsPaymentFee[i].fee_amount=this.$options.filters.currencyFormat(  this.lsPaymentFee[i].fee_amount,this.lsPaymentFee[i].currency);
          }
    
        } catch (err) {
                let body = Logger.buildRequest(
                  FILE_NAME.C_PAYMENT_TYPES,
                  "error in formatLsPaymentFee",
                  err.toString(),
                  "formatLsPaymentFee",
                  LOG_TYPE.ERROR
                );
                Logger.getResponse(body);
              }
          
        }, 

    async updatePaymentFee() {
      let retValue;
      try {
        if (BaseConfiguration.isDebug) console.log("updatePaymentFee");

        if (this.lsPaymentFee && this.lsPaymentFee.length > 0) {

               this.lsPaymentFee.forEach(fee=>{

               fee.fee_amount=   parseFloat( fee.fee_amount.toString().split(",").join(""))
               fee.fee_perc=parseFloat( fee.fee_perc.toString().split(",").join(""))

               });

          let updatePaymentFeeReq = apiUpdatePaymentFee.buildRequest(
            this.lsPaymentFee
          );
          if (updatePaymentFeeReq) {
            let updatePaymentFeeRes = await apiUpdatePaymentFee.getResponse(
              updatePaymentFeeReq
            );
            if (VALIDATE_SUCCESS_RES(updatePaymentFeeRes)) {
              retValue = updatePaymentFeeRes.data.data;
              this.hidePaymentFeeModal();
              this.toggleAlertModal();
              this.alertValue == null;
            } else {
              let error = getErrorMessage(updatePaymentFeeReq);

              let isJwt = handleJWT(error);
              if (!isJwt) {
                this.alertValue = getErrorAlertValue(error);
              }
            }
          } else {
            throw "invalid request update payment fee";
          }
        } else {
          throw "invalid payment fee list";
        }
      } catch (err) {
        let body = Logger.buildRequest(
          FILE_NAME.C_PAYMENT_TYPES,
          "error in updatePaymentFee",
          err.toString(),
          "updatePaymentFee",
          LOG_TYPE.ERROR
        );
        Logger.getResponse(body);
      }
      return retValue;
    },

    async getPaymentFee(pPsettID, pPtype) {
      let retValue = [];
      try {
        if (BaseConfiguration.isDebug) console.log("getPaymentFee");

        if (pPsettID && pPtype) {
          let paymentFeeReq = apiGetPaymentFee.buildRequest(pPsettID, pPtype);
          if (paymentFeeReq) {
            let paymentFeeRes = await apiGetPaymentFee.getResponse(
              paymentFeeReq
            );
            if (VALIDATE_SUCCESS_RES(paymentFeeRes)) {
              retValue = paymentFeeRes.data.data;

              this.alertValue == null;
            } else {
              let error = getErrorMessage(allPaymentTypesRes);

              let isJwt = handleJWT(error);
              if (!isJwt) {
                this.alertValue = getErrorAlertValue(error);
              }
            }
          } else {
            throw "invalid request payment fee";
          }
        } else {
          throw "invalid payment types or SettingsID";
        }
      } catch (err) {
        let body = Logger.buildRequest(
          FILE_NAME.C_PAYMENT_TYPES,
          "error in getPaymentFee",
          err.toString(),
          "getPaymentFee",
          LOG_TYPE.ERROR
        );
        Logger.getResponse(body);
      }
      return retValue;
    },

    async getAllPaymentTypes() {
      let retValue;
      try {
        if (BaseConfiguration.isDebug) console.log("getAllPaymentTypes");

        let allPaymentTypesReq = apiGetAllPaymentTypes.buildRequest();

        if (allPaymentTypesReq) {
          let allPaymentTypesRes = await apiGetAllPaymentTypes.getResponse(
            allPaymentTypesReq
          );
          if (VALIDATE_SUCCESS_RES(allPaymentTypesRes)) {
            if (
              allPaymentTypesRes &&
              allPaymentTypesRes.data.data &&
              allPaymentTypesRes.data.data
            )
              retValue = allPaymentTypesRes.data.data;

            this.alertValue = null;
          } else {
            let error = getErrorMessage(allPaymentTypesRes);

            let isJwt = handleJWT(error);
            if (!isJwt) {
              this.alertValue = getErrorAlertValue(error);
            }
          }
        } else {
          throw "invalid payment types request";
        }
      } catch (err) {
        let body = Logger.buildRequest(
          FILE_NAME.C_PAYMENT_TYPES,
          "error in getAllPaymentTypes",
          err.toString(),
          "getAllPaymentTypes",
          LOG_TYPE.ERROR
        );
        Logger.getResponse(body);
      }
      return retValue;
    },
        






    getSelectedPaymentTypes(pPaymentTypesList) {
      let retValue = [];
      try {
        if (BaseConfiguration.isDebug) console.log("getSelectedPaymentTypes");

        if (pPaymentTypesList && pPaymentTypesList.length) {
          pPaymentTypesList.forEach(type => {
            if (this.selPayments && this.selPayments.length) {
              let selPayment = this.selPayments.find(payment => {
                return type.payment_type == payment.payment_type;
              });

              if (selPayment && selPayment.paymentfee_isactive != null) {
                type.isActive = selPayment.paymentfee_isactive;
              }
            } else {
              type.isActive = false;
            }
          });

          retValue = pPaymentTypesList;
        }
      } catch (err) {
        let body = Logger.buildRequest(
          FILE_NAME.C_PAYMENT_TYPES,
          "error in getSelectedPaymentTypes",
          err.toString(),
          "getSelectedPaymentTypes",
          LOG_TYPE.ERROR
        );
        Logger.getResponse(body);
      }
      return retValue;
    }
  },

  mounted() {},

  async created() {
    try {
      if (BaseConfiguration.isDebug) console.log("created");
      this.paymentTypes = await this.getAllPaymentTypes();

      if (
        this.paymentTypes &&
        this.paymentTypes.B2B &&
        this.paymentTypes.B2B.length
      )
        this.paymentTypes.B2B = this.getSelectedPaymentTypes(
          this.paymentTypes.B2B
        );

      if (
        this.paymentTypes &&
        this.paymentTypes.B2C &&
        this.paymentTypes.B2C.length
      )
        this.paymentTypes.B2C = this.getSelectedPaymentTypes(
          this.paymentTypes.B2C
        );

      this.onTypeChange();

    } catch (err) {
      let body = Logger.buildRequest(
        FILE_NAME.C_PAYMENT_TYPES,
        "error in created",
        err.toString(),
        "created",
        LOG_TYPE.ERROR
      );
      Logger.getResponse(body);
    }
  },
   watch: {
    
        
        }



};
</script>
